import { observable, action } from 'mobx';

class EndLiveClassStore {
  @observable.ref isPopupVisible = false;

  constructor(store) {
    this.store = store;
  }

  @action
  showPopup = () => {
    this.isPopupVisible = true;
  };

  @action
  hidePopup = () => {
    this.isPopupVisible = false;
  };

  handleExit = () => {
    window.location.href = '/#/learner';
    this.isPopupVisible = false;
  };
}

export default EndLiveClassStore;
